import React, { useEffect, useRef } from "react";
import styles from "./styles.css";
import loadable from "@loadable/component";
import PropTypes from "prop-types";
import ChatWidgetRevamp from "../chat-widget-revamp/component";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import { AU_DESKTOP_EVENTS } from "../../../tracking/au.desktop-events";
import { preloadScriptWithWorker } from "../../../utils/helpers/load-script-web-worker";
import { getAbExpirementVariant } from "../../../utils/helpers/get-ab-expirement-variant";
import { EXPERIMENT_TYPE } from "../../../constants/optimize-constants";
import { HUBSPOT_ASSISTANCE_SCRIPT } from "./constant";
import useMutationObserver from "../../../hooks/use-mutation-observer";
const HelpSupportModal = loadable(() => import("../help-support-modal/component"));
const ContactSelectModal = loadable(() => import("../contact-select-modal"));

const SupportWidget = ({
    showWidget = true,
    isSellCarPage = false,
    supportWidget,
    showHelpSupportModalConnect,
    showEmailSupportModalConnect,
    desktopHubspotAssistance
}) => {
    const isSupportWidgetVariantB = getAbExpirementVariant(desktopHubspotAssistance, EXPERIMENT_TYPE.VARIANT_B);
    const bodyRef = useRef(null);
    const observerRef = useRef(null);

    const { showHelpSupportModal, showEmailSupportModal, hideWidgetIcon } = supportWidget;

    const handleHubspotWidgetMutation = () => {
        const widgetContainer = document.querySelector("#hubspot-messages-iframe-container");
        if (widgetContainer) {
            widgetContainer.style.setProperty("bottom", "35px", "important");
            const {current: observer} = observerRef?.current;
            observer.disconnect();
        }
    };

    useEffect(() => {
        if (isSupportWidgetVariantB) {
            preloadScriptWithWorker(
                HUBSPOT_ASSISTANCE_SCRIPT,
                (scriptContent) => {
                    const script = document.createElement("script");
                    script.textContent = scriptContent;
                    script.id = "hs-script-loader";
                    document.body.appendChild(script);
                },
                () => {
                    // console.error("Failed to load script:", error);
                }
            );

            if (document) bodyRef.current = document.body;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSupportWidgetVariantB]);

    observerRef.current = useMutationObserver(bodyRef, handleHubspotWidgetMutation, {
        childList: true,
        subtree: true
    });

    const handleEmailUsModal = (val) => {
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.HELP_SUPPORT_ICON_CLICKED, {
            eventLabel: window.location.href
        });
        showEmailSupportModalConnect(val);
    };

    const handleHelpModal = (val) => {
        showHelpSupportModalConnect(val);
    };

    const handleWidgetIconClick = () => {
        if (isSellCarPage) {
            handleHelpModal(!showHelpSupportModal);
            handleEmailUsModal(false);
        } else {
            handleHelpModal(false);
            handleEmailUsModal(!showEmailSupportModal);
        }
    };

    const handleSubmitCallback = () => {
        showEmailSupportModalConnect(false);
    };

    if (!showWidget) return null;

    if (!isSupportWidgetVariantB) {
        return (
            <React.Fragment>
                {!hideWidgetIcon ? <ChatWidgetRevamp onClick={handleWidgetIconClick} /> : null}
                {showHelpSupportModal && isSellCarPage && (
                    <HelpSupportModal handleEmailUsModal={handleEmailUsModal} handleHelpModal={handleHelpModal} />
                )}
                {showEmailSupportModal && (
                    <ContactSelectModal
                        emailSupportModal={showEmailSupportModal}
                        isSellCarPage={isSellCarPage}
                        handleEmailUsModal={handleEmailUsModal}
                        handleHelpModal={handleHelpModal}
                        onSubmitCallback={handleSubmitCallback}
                    />
                )}
            </React.Fragment>
        );
    } else return null;
};
export default SupportWidget;

SupportWidget.propTypes = {
    showWidget: PropTypes.bool,
    isSellCarPage: PropTypes.bool,
    supportWidget: PropTypes.object,
    showHelpSupportModalConnect: PropTypes.func,
    showEmailSupportModalConnect: PropTypes.func,
    desktopHubspotAssistance: PropTypes.object
};
